import { CategoryItemPropsTemporary } from '@/shared/types/deprecated-types'
import { Text } from '@/shared/ui'
import { Col, Row } from '@/shared/ui/Grid'

import { PageItem } from './PageItem/PageItem'

import styles from './FooterPageList.module.scss'

export interface FooterPagePart {
	title: string
	items: CategoryItemPropsTemporary[]
}

export interface FooterPageListProps {
	footerPage: FooterPagePart[]
}

export const FooterPageList = ({ footerPage }: FooterPageListProps) => (
	<div className={styles.footerPageList}>
		<Row gutter={30}>
			{/* Page lists */}
			{footerPage.map(({ title, items }) => (
				<Col key={title} xs={24} sm={8}>
					{/* Page list title */}
					<Text as="div" className={styles.categoryTitle} weight="medium">
						{title}
					</Text>

					{/* Page list */}
					<ul className={styles.categoryPageList}>
						{items.map(({ link, title, targetBlank }) => (
							// Page item
							<PageItem key={title} link={link} title={title} targetBlank={targetBlank} />
						))}
					</ul>
				</Col>
			))}
		</Row>
	</div>
)
